
import { FormElementController, FormElementValidator, StringValidators} from './../../../scripts/formcontrols'


export class CarehomeCreateController {
    public name: FormElementController<string>;
    public dob: FormElementController<string>;

    constructor() {
        //this.name = new FormController<string>("Name", new FormElementValidator(true));

        var nameValidator = new FormElementValidator<string>(true, StringValidators.MinLength(5));
       

        this.name = new FormElementController<string>("Name", "", nameValidator);
        

    }
}


// WEBPACK FOOTER //
// ./ClientApp/components/carehome/create/carehome-create-controller.ts